import React, { useEffect } from "react";
import { useState } from "react";
import { Container, Row, Col, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { BsTable } from "react-icons/bs";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import ReportHeader from "./report-header";
import { getPortfolioByDate } from "../../stores/services/daily-unrealized-portfolio.service";
import { getFundByAmc } from "../../stores/services/funds.service";
import { exportToTxt, generateExcel, numberWithCommas } from "../../utils/customFunction";
import { useSelector } from "react-redux";
import Select from "react-select";
import ReportTemplates from "../../components/ReportTemplate/ReportTemplate";
import html2pdf from "html2pdf.js";

const DailyPortfolioReport = () => {
  const contentRef = React.useRef(null);
  const portfolioArr = [
    { label: "Money Market", value: "Money Market" },
    { label: "Stock Market", value: "Stock Market" },
  ];

  const ColumnHeadingMM = [
    { label: "Symbol", value: "Symbol" },
    { label: "Security Type", value: "Security Type" },
    { label: "Name", value: "Name" },
    { label: "Issue Date", value: "Issue Date" },
    { label: "Maturity Date", value: "Maturity Date" },
    { label: "Coupon Rate %", value: "Coupon Rate %" },
    { label: "Yield %", value: "Yield %" },
    { label: "Money Market Face Value/Unit", value: "Money Market Face Value/Unit" },
    { label: "Total Face Value", value: "Total Face Value" },
    { label: "Units", value: "Units" },
    { label: "Average Cost / Unit", value: "Average Cost / Unit" },
    { label: "Total Cost / Amount", value: "Total Cost / Amount" },
    { label: "Market Rate/Unit", value: "Market Rate/Unit" },
    { label: "Market Value", value: "Market Value" },
    { label: "Unrealized Gain/(Loss)", value: "Unrealized Gain/(Loss)" },
    { label: "Investment as % Market Value", value: "Investment as % Market Value" }
  ];

  const ColumnHeadingSM = [
    { label: "Symbol", value: "Symbol" },
    { label: "Market", value: "Market" },
    { label: "Total Units", value: "Total Units" },
    { label: "Available Units", value: "Available Units" },
    { label: "Average Cost / Unit", value: "Average Cost / Unit" },
    { label: "Total Cost / Amount", value: "Total Cost / Amount" },
    { label: "Market Rate/Unit", value: "Market Rate/Unit" },
    { label: "Market Value", value: "Market Value" },
    { label: "Unrealized Gain/(Loss)", value: "Unrealized Gain/(Loss)" },
    { label: "Investment as % Market Value", value: "Investment as % Market Value" }
  ];
  const [ColumnArr, setColumnArr] = useState(ColumnHeadingSM)
  const [selectedValues, setSelectedValues] = useState<any>({
    heading: "",
    sub_heading: "",
    columns: ColumnHeadingSM?.map?.((col) => col?.value),
    balance: ["Opening Balance", "Closing Balance"]
  })
  const [fontSizeVal, setFontSizeVal] = useState<any>(18)
  const [paperSizeVal, setPaperSizeVal] = useState("A4")
  const [layoutVal, setLayoutVal] = useState("Landscape")
  const [marginPDF, setMarginPDF] = useState("1cm");
  const [scalePDF, setScalePDF] = useState(0.5);
  const [screenSizePerPdf, setScreenSizePerPdf] = useState()
  const [dimensionOfPages, setDimensionOfPages] = useState<any>()
  const [itemsPerPage, setItemsPerPage] = useState<any>(10)
  const [itemsToShow, setItemsToShow] = useState(10);
  const [isSearchTrue, setIsSearchTrue] = useState(false);

  const [screen, setScreen] = useState<any>()
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);

  const pdfExportComponent = React.useRef<PDFExport>(null);
  const [loading, setLoading] = useState(false);
  const email = sessionStorage.getItem("email") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const amc_name = sessionStorage.getItem("amc_name") || "";
  const [fund_code, setFund_code] = useState(
    JSON.parse(sessionStorage.getItem("fund_code") || "[]")
  );
  let date = new Date();

  const [funds, setFunds] = useState<any>([]);

  const [fundPortfolio, setFundPortfolio] = useState<any>([]);
  const [moneyMarketPortfolio, setMoneyMarketPortfolio] = useState<any>([]);
  const [stockMarketPortfolio, setStockMarketPortfolio] = useState<any>([]);
  const [fundCode, setFundCode] = useState("");
  const [selectedPortfolio, setSelectedPortfolio] = useState("");
  const [createdDate, setCreatedDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  const [resFundCode, setResFundCode] = useState("");
  const [resSelectedPortfolio, setResSelectedPortfolio] = useState("");
  const [resCreatedDate, setResCreatedDate] = useState("");

  const [funCodeErr, setFundCodeErr] = useState("");
  const [selectedPortfolioErr, setSelectedPortfolioErr] = useState("");
  const [createdDateErr, setCreatedDateErr] = useState("");

  const getFundsByAmcCode = async () => {
    try {
      const response = await getFundByAmc(
        email,
        amc_code,
        fund_code?.length > 0 ? fund_code : ""
      );
      // sort data
      let sortedData: any = [];
      sortedData = response.data.data.sort(function (a, b) {
        let x = a.nature.toLowerCase();
        let y = b.nature.toLowerCase();
        if (x > y) {
          return 1;
        }
        if (x < y) {
          return -1;
        }
        return 0;
      });
      // setAllFunds(response.data.data);
      setFunds(sortedData);
    } catch (error) { }
  };

  // useEffect(() => {
  //   getFundsByAmcCode();
  // }, []);

  React.useEffect(() => {
    if (sessionStorage.getItem("fund_code")) {
      setFund_code(JSON.parse(sessionStorage.getItem("fund_code") || "[]"));
    } else {
      setFund_code(undefined);
    }
  }, []);

  React.useEffect(() => {
    const handleStorageChange = () => {
      const fundCode = sessionStorage.getItem("fund_code");
      setFund_code(fundCode ? JSON.parse(fundCode) : undefined);
    };

    handleStorageChange();

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  React.useEffect(() => {
    getFundsByAmcCode();
  }, [fund_code]);

  // const renderFundsDropDown = () => {
  //   return funds.map((item: any, index: number) => {
  //     return (
  //       <option key={index} value={item.symbol_code}>
  //         {item.fund_name} - {item.symbol_code}
  //       </option>
  //     );
  //   });
  // }

  const renderFundsDropDown = () => {
    return funds.map((item: any, index: number) => {
      return {
        value: item.symbol_code,
        label: `${item.fund_name} - ${item.symbol_code}`,
      };
    });
  };

  const validate = () => {
    let fundError = "";
    let portfolioError = "";
    let dateErr = "";
    fundCode?.trim() === ""
      ? (fundError = "required-border")
      : (fundError = "");
    selectedPortfolio?.trim() === ""
      ? (portfolioError = "required-border")
      : (portfolioError = "");
    createdDate?.trim() === "" ? (dateErr = "required-border") : (dateErr = "");
    if (fundError || portfolioError || dateErr) {
      setFundCodeErr(fundError);
      setSelectedPortfolioErr(portfolioError);
      setCreatedDateErr(dateErr);
      return false;
    } else {
      return true;
    }
  };

  //code for search data for Reports

  const searchData = async () => {
    setIsSearchTrue(false)
    setItemsPerPage(10)
    // setFundPortfolio([])
    // setStockMarketPortfolio([])
    // setMoneyMarketPortfolio([])
    const isValid = validate();
    if (isValid) {
      try {
        setLoading(true);
        setResFundCode("");
        setResSelectedPortfolio("");
        setResCreatedDate("");
        const response = await getPortfolioByDate(
          email,
          amc_code,
          fundCode,
          createdDate
        );
        if (response.data.data.length > 0) {
          setFundPortfolio(response.data.data);
          if (selectedPortfolio == "Money Market") {
            // let sortedData:any=[];
            //  sortedData = JSON.parse(response.data.data[0].money_market).sort(function(a,b){
            //    let x = a.code.toLowerCase();
            //    let y = b.code.toLowerCase();
            //    if(x>y){return 1;}
            //    if(x<y){return -1;}
            //    return 0;
            //  });
            //  moneyMarketScripWise(sortedData);
            //  setMoneyMarketPortfolio(moneyMarketScripWise(sortedData));
            setMoneyMarketPortfolio(
              JSON.parse(response.data.data[0].money_market)
            );
          } else {
            //     let sortedData:any=[];
            //     sortedData = JSON.parse(response.data.data[0].stock_market).sort(function(a,b){
            //       let x = a.code.toLowerCase();
            //       let y = b.code.toLowerCase();
            //       if(x>y){return 1;}
            //       if(x<y){return -1;}
            //       return 0;
            //     });

            //  setStockMarketPortfolio(stockMarketScripWise(sortedData));
            setStockMarketPortfolio(
              JSON.parse(response.data.data[0].stock_market)
            );
          }
          setResFundCode(fundCode);
          setResSelectedPortfolio(selectedPortfolio);
          setResCreatedDate(createdDate);
        } else {
          moneyMarketPortfolio.length = 0;
          setMoneyMarketPortfolio(moneyMarketPortfolio);
          stockMarketPortfolio.length = 0;
          setStockMarketPortfolio(stockMarketPortfolio);
          toast.error(response.data.message);
        }
        setIsSearchTrue(true)
        setFontSizeVal(18)
        setLoading(false);
      } catch (error) {
        setIsSearchTrue(false)
        setLoading(false);
      }
    }
  };

  // money market scrip wise
  // const moneyMarketScripWise=(portfolio:any)=>{
  //   let uniqueSymbols = Array.from(new Set(portfolio.map(x=>x.security_type)));
  //          let allArraysFiltered = uniqueSymbols.map((uniqueKey :any) =>{
  //           let filterData = portfolio.filter(item=>{
  //           return uniqueKey==item.security_type;
  //           });
  //           return filterData;
  //          }); // end map

  //         let filteredArraysWithTotalRowAdded: any = [];
  //           allArraysFiltered.forEach(filterArray => {
  //           if(filterArray.length > 1) {
  //          let rowAdded : any =  filterArray.reduce((row1 , row2) => {
  //            return {
  //              code:'~~~'+row1.security_type+' Total:',
  //              coupon_rate : (+row1.coupon_rate + +row2.coupon_rate).toFixed(2),
  //                               yield : (+row1.yield + +row2.yield).toFixed(2),
  //                               mmface_value : (+row1.mmface_value + +row2.mmface_value).toFixed(4),
  //                               total_face_value : (+row1.total_face_value + +row2.total_face_value).toFixed(4),
  //                               units : (+row1.units + +row2.units).toFixed(4),
  //                               total_amount : (+row1.total_amount + +row2.total_amount).toFixed(2),
  //                               market_value : (+row1.market_value + +row2.market_value).toFixed(2),
  //                               unrealized_gain_loss : (+row1.unrealized_gain_loss + +row2.unrealized_gain_loss).toFixed(2),
  //                               investment_percentage_market_value : (+row1.investment_percentage_market_value + +row2.investment_percentage_market_value).toFixed(2),
  //            }
  //          })
  //          filteredArraysWithTotalRowAdded.push([...filterArray , rowAdded , {}])
  //        }
  //        else {
  //          let objToShowInSingle = {
  //           code:'~~~'+filterArray[0].security_type+' Total:',
  //           // type:'Scrip wise Total:',
  //           coupon_rate : (parseFloat(filterArray[0].coupon_rate || '0')).toFixed(2) ,
  //           yield : (parseFloat(filterArray[0].yield || '0')).toFixed(2),
  //           mmface_value : (parseFloat(filterArray[0].mmface_value || '0')).toFixed(2),
  //           units : (parseFloat(filterArray[0].units || '0')).toFixed(2),
  //          total_face_value : (parseFloat(filterArray[0].total_face_value || '0')).toFixed(2),
  //          //  commission_rate : (parseFloat(row1.commission_rate || '0') + parseFloat(row2.commission_rate || '0')).toFixed(2),
  //          //  avg_rate : (parseFloat(row1.avg_rate || '0') + parseFloat(row2.avg_rate || '0')).toFixed(2),
  //          total_amount : (parseFloat(filterArray[0].total_amount || '0')),
  //          market_value : (parseFloat(filterArray[0].market_value || '0')),
  //          unrealized_gain_loss : (parseFloat(filterArray[0].unrealized_gain_loss || '0')),
  //          investment_percentage_market_value : (parseFloat(filterArray[0].investment_percentage_market_value || '0')),
  //          }
  //          filteredArraysWithTotalRowAdded.push([...filterArray ,objToShowInSingle, {}])
  //        }
  //      });

  //      let seperatedArray :any = [];
  //      filteredArraysWithTotalRowAdded.forEach(item => {
  //         item.forEach(objItem => {
  //         seperatedArray.push(objItem)
  //         })

  //       })
  //       return seperatedArray;

  // }

  // const stockMarketScripWise=(portfolio:any)=>{
  //   let uniqueSymbols = Array.from(new Set(portfolio.map(x=>x.code)));
  //          let allArraysFiltered = uniqueSymbols.map((uniqueKey :any) =>{
  //           let filterData = portfolio.filter(item=>{
  //           return uniqueKey==item.code;
  //           });
  //           return filterData;
  //          }); // end map

  //         let filteredArraysWithTotalRowAdded: any = [];
  //           allArraysFiltered.forEach(filterArray => {
  //           if(filterArray.length > 1) {
  //          let rowAdded : any =  filterArray.reduce((row1 , row2) => {
  //            return {
  //              code:'~~~'+row1.code+' Total:',
  //              unit : (+row1.unit + +row2.unit).toFixed(4),
  //             total_units : (+row1.total_units + +row2.total_units).toFixed(4),
  //             amount : (+row1.total_amount + +row2.amount).toFixed(2),
  //             market_value : (+row1.market_value + +row2.market_value).toFixed(2),
  //             unrealized_gain_loss : (+row1.unrealized_gain_loss + +row2.unrealized_gain_loss).toFixed(2),
  //             investment_percentage_market_value : (+row1.investment_percentage_market_value + +row2.investment_percentage_market_value).toFixed(2),
  //            }
  //          })
  //          filteredArraysWithTotalRowAdded.push([...filterArray , rowAdded , {}])
  //        }else {
  //          let objToShowInSingle = {
  //           code:'~~~'+filterArray[0].code+' Total:',
  //           unit : (+filterArray[0].unit).toFixed(4),
  //             total_units : (+filterArray[0].total_units).toFixed(4),
  //             amount : (+filterArray[0].amount).toFixed(2),
  //             market_value : (+filterArray[0].market_value).toFixed(2),
  //             unrealized_gain_loss : (+filterArray[0].unrealized_gain_loss).toFixed(2),
  //             investment_percentage_market_value : (+filterArray[0].investment_percentage_market_value).toFixed(2),
  //          }
  //          filteredArraysWithTotalRowAdded.push([...filterArray ,objToShowInSingle, {}])
  //        }
  //      });

  //      let seperatedArray :any = [];
  //      filteredArraysWithTotalRowAdded.forEach(item => {
  //         item.forEach(objItem => {
  //         seperatedArray.push(objItem)
  //         })

  //       })
  //       return seperatedArray;

  // }

  let coupon_rate = "0",
    yields = "0",
    mmface_value = "0",
    total_face_value = "0",
    units = "0",
    total_units = "0",
    total_amount = "0",
    market_value = "0",
    unrealized_gain_loss = "0",
    investment_percentage_market_value = "0";

  const selectedFundName = React.useMemo(() => {
    const selectedFund = funds.find((item) => item?.symbol_code === fundCode);
    return selectedFund
      ? {
        value: selectedFund.symbol_code,
        label: `${selectedFund.fund_name} (${selectedFund.symbol_code})`,
      }
      : null;
  }, [funds, fundCode]);

  const selectedPortfolioVal = React.useMemo(() => {
    return selectedPortfolio
      ? {
        value: selectedPortfolio,
        label: selectedPortfolio,
      }
      : null;
  }, [selectedPortfolio]);

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      background: isFocused
        ? "hsla(291, 64%, 42%, 0.5)"
        : isSelected
          ? "hsla(291, 64%, 42%, 1)"
          : undefined,
      zIndex: 1,
    }),
    menuList: (styles) => ({
      ...styles,
      background: theme == "dark" ? "#3b3b3b" : "#ffffff",
      color: theme == "dark" ? "white" : "",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
    control: (base, state) => ({
      ...base,
      background: theme == "dark" ? "#25273a" : "#f2f2f2",
      borderRadius: "0.4285rem",
      borderColor: state.isFocused
        ? "#1d8cf8"
        : theme !== "light"
          ? "#2b3553"
          : "",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "" : "#ba54f5",
      },
      '& .react-select__input input[type="color"]': {
        color: theme === "dark" ? "red" : "black",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme == "dark" ? "white" : "black",
    }),
    input: (base) => ({
      ...base,
      color: theme == "dark" ? "white" : "black",
    }),
  };

  const fixedOrderMM = [
    "Symbol",
    "Security Type",
    "Name",
    "Issue Date",
    "Maturity Date",
    "Coupon Rate %",
    "Yield %",
    "Money Market Face Value/Unit",
    "Total Face Value",
    "Units",
    "Average Cost / Unit",
    "Total Cost / Amount",
    "Market Rate/Unit",
    "Market Value",
    "Unrealized Gain/(Loss)",
    "Investment as % Market Value"
  ];

  const fixedOrderSM = [
    "Symbol",
    "Market",
    "Total Units",
    "Available Units",
    "Average Cost / Unit",
    "Total Cost / Amount",
    "Market Rate/Unit",
    "Market Value",
    "Unrealized Gain/(Loss)",
    "Investment as % Market Value"
  ];


  useEffect(() => {
    const elements = document.querySelectorAll("#test") as NodeListOf<HTMLElement>;
    elements.forEach((element) => {
      element.style.setProperty("font-size", `${fontSizeVal}px`, "important");
    });
  }, [fontSizeVal]);

  useEffect(() => {
    const handleScreenResize = () => {
      setScreen(window?.outerWidth)
    }

    window.addEventListener("resize", handleScreenResize)
    handleScreenResize()

    return () => {
      window.removeEventListener("resize", handleScreenResize)
    }

  }, [])


  const handleDownloadSampleFile = () => {

    const headings = [
      [selectedValues?.heading ? selectedValues?.heading : "", "", "", ""],
      [selectedValues?.sub_heading ? selectedValues?.sub_heading : "", "", "", ""],
      ["Fund", `${resFundCode}`, "Portfolio", `${resSelectedPortfolio}`],
      ["Date", `${moment(resCreatedDate).format("DD-MM-YYYY")}`, "Report Date", `${moment(date).format("DD-MM-YYYY")}`],
    ];

    const dataSequence = resSelectedPortfolio == "Money Market" ? moneyMarketPortfolio?.slice(0, itemsToShow)?.map((items) => {
      let coupon_rate = "0",
        yields = "0",
        mmface_value = "0",
        total_face_value = "0",
        units = "0",
        total_amount = "0",
        market_value = "0",
        unrealized_gain_loss = "0",
        investment_percentage_market_value = "0";
      coupon_rate = (
        +coupon_rate + +items.coupon_rate
      ).toFixed(4);
      yields = (
        +yields + +items.yield
      ).toFixed(4);
      mmface_value = (
        +mmface_value + +items.mmface_value
      ).toFixed(4);
      total_face_value = (
        +total_face_value +
        +items.total_face_value
      ).toFixed(4);
      units = (+units + +items.units).toFixed(
        4
      );
      total_amount = (
        +total_amount + +items.total_amount
      ).toFixed(4);
      market_value = (
        +market_value + +items.market_value
      ).toFixed(4);
      unrealized_gain_loss = (
        +unrealized_gain_loss +
        +items.unrealized_gain_loss
      ).toFixed(4);
      investment_percentage_market_value = (
        +investment_percentage_market_value +
        +items.investment_percentage_market_value
      ).toFixed(4);
      return {
        Symbol: items.code,
        Security_Type: items.security_type,
        Name: items.name,
        Issue_Date: items.issue_date,
        Maturity_Date: items.maturity_date,
        Coupon_Rate_Percentage: +items.coupon_rate < 0
          ? numberWithCommas(
            "(" +
            items.coupon_rate
              .toString()
              .replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(
            items.coupon_rate || ""
          ),
        Yield_Percentage: +items.yield < 0
          ? numberWithCommas(
            "(" +
            items.yield
              .toString()
              .replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(
            items.yield || ""
          ),
        Money_Market_Face_Value_Unit: +items.mmface_value < 0
          ? numberWithCommas(
            "(" +
            items.mmface_value
              .toString()
              .replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(
            items.mmface_value || ""
          ),
        Total_Face_Value: +items.total_face_value < 0
          ? numberWithCommas(
            "(" +
            items.total_face_value
              .toString()
              .replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(
            items.total_face_value ||
            ""
          ),
        Units: +items.units < 0
          ? numberWithCommas(
            items.units || ""
          )
          : numberWithCommas(
            items.units || ""
          ),
        Average_Cost_Unit: +items.average_cost_per_unit <
          0
          ? numberWithCommas(
            "(" +
            items.average_cost_per_unit
              .toString()
              .replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(
            items.average_cost_per_unit ||
            ""
          ),
        Total_Cost_Amount: +items.total_amount < 0
          ? numberWithCommas(
            "(" +
            items.total_amount
              .toString()
              .replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(
            items.total_amount || ""
          ),
        Market_Rate_Unit: +items.market_rate_per_unit < 0
          ? numberWithCommas(
            "(" +
            items.market_rate_per_unit
              .toString()
              .replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(
            items.market_rate_per_unit ||
            ""
          ),
        Market_Value: +items.market_value < 0
          ? numberWithCommas(
            "(" +
            items.market_value
              .toString()
              .replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(
            items.market_value || ""
          ),
        Unrealized_Gain_Loss: +items.unrealized_gain_loss < 0
          ? numberWithCommas(
            "(" +
            items.unrealized_gain_loss
              .toString()
              .replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(
            items.unrealized_gain_loss ||
            ""
          ),
        Investment_as_Percentage_of_Market_Value: +items.investment_percentage_market_value <
          0
          ? numberWithCommas(
            "(" +
            items.investment_percentage_market_value
              .toString()
              .replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(
            items.investment_percentage_market_value ||
            ""
          ),
      }
    }) : stockMarketPortfolio?.slice(0, itemsToShow)?.map((items) => {
      let units = "0",
        total_amount = "0",
        total_units = "0",
        market_value = "0",
        unrealized_gain_loss = "0",
        investment_percentage_market_value = "0";
      units = (+units + +items.unit).toFixed(
        4
      );
      total_units = (
        +total_units + +items.total_units
      ).toFixed(4);
      total_amount = (
        +total_amount + +items.amount
      ).toFixed(4);
      market_value = (
        +market_value + +items.market_value
      ).toFixed(4);
      unrealized_gain_loss = (
        +unrealized_gain_loss +
        +items.unrealized_gain_loss
      ).toFixed(4);
      investment_percentage_market_value = (
        +investment_percentage_market_value +
        +items.investment_percentage_market_value
      ).toFixed(4);
      return {
        Symbol: items.code,
        Market: items.market,
        Total_Units: +items.total_units < 0
          ? numberWithCommas(
            "(" +
            items.total_units.replace(
              "-",
              ""
            ) +
            ")" || ""
          )
          : numberWithCommas(
            items.total_units || ""
          ),
        Available_Units: +items.unit < 0
          ? numberWithCommas(
            "(" +
            items.unit.replace(
              "-",
              ""
            ) +
            ")" || ""
          )
          : numberWithCommas(
            items.unit || ""
          ),
        Average_Cost_Unit: +items.average_cost_per_unit <
          0
          ? numberWithCommas(
            "(" +
            items.average_cost_per_unit.replace(
              "-",
              ""
            ) +
            ")"
          )
          : numberWithCommas(
            items.average_cost_per_unit
          ),
        Total_Cost_Amount: +items.amount < 0
          ? numberWithCommas(
            "(" +
            items.amount.replace(
              "-",
              ""
            ) +
            ")" || ""
          )
          : numberWithCommas(
            items.amount
          ),
        Market_Rate_Unit: +items.market_rate_per_unit < 0
          ? numberWithCommas(
            "(" +
            items.market_rate_per_unit.replace(
              "-",
              ""
            ) +
            ")"
          )
          : numberWithCommas(
            items.market_rate_per_unit
          ),
        Market_Value: +items.market_value < 0
          ? numberWithCommas(
            "(" +
            items.market_value.replace(
              "-",
              ""
            ) +
            ")"
          )
          : numberWithCommas(
            items.market_value
          ),
        Unrealized_Gain_Loss: +items.unrealized_gain_loss < 0
          ? numberWithCommas(
            "(" +
            items.unrealized_gain_loss.replace(
              "-",
              ""
            ) +
            ")"
          )
          : numberWithCommas(
            items.unrealized_gain_loss
          ),
        Investment_as_Percentage_of_Market_Value: +items.investment_percentage_market_value <
          0
          ? numberWithCommas(
            "(" +
            items.investment_percentage_market_value.replace(
              "-",
              ""
            ) +
            ")"
          )
          : numberWithCommas(
            items.investment_percentage_market_value
          ),
      }
    })

    resSelectedPortfolio == "Money Market" ? dataSequence.push({
      Symbol: "Grand Total",
      Security_Type: "",
      Name: "",
      Issue_Date: "",
      Maturity_Date: "",
      Coupon_Rate_Percentage: selectedValues?.columns?.includes("Coupon Rate %") && +coupon_rate < 0
        ? numberWithCommas(
          "(" +
          coupon_rate.replace("-", "") +
          ")" || ""
        )
        : numberWithCommas(coupon_rate || ""),
      Yield_Percentage: selectedValues?.columns?.includes("Yield %") && +yields < 0
        ? numberWithCommas(
          "(" +
          yields.replace("-", "") +
          ")" || ""
        )
        : numberWithCommas(yields || ""),
      Money_Market_Face_Value_Unit: selectedValues?.columns?.includes("Money Market Face Value/Unit") && +mmface_value < 0
        ? numberWithCommas(
          "(" +
          mmface_value.replace("-", "") +
          ")" || ""
        )
        : numberWithCommas(
          mmface_value || ""
        ),
      Total_Face_Value: selectedValues?.columns?.includes("Total Face Value") && +total_face_value < 0
        ? numberWithCommas(
          "(" +
          total_face_value.replace(
            "-",
            ""
          ) +
          ")" || ""
        )
        : numberWithCommas(
          total_face_value || ""
        ),
      Units: selectedValues?.columns?.includes("Units") && +units < 0
        ? numberWithCommas(
          "(" +
          units.replace("-", "") +
          ")" || ""
        )
        : numberWithCommas(units || ""),
      Average_Cost_Unit: "",
      Total_Cost_Amount: selectedValues?.columns?.includes("Total Cost / Amount") && +total_amount < 0
        ? numberWithCommas(
          "(" +
          total_amount.replace("-", "") +
          ")" || ""
        )
        : numberWithCommas(
          total_amount || ""
        ),
      Market_Rate_Unit: "",
      Market_Value: selectedValues?.columns?.includes("Market Value") && +market_value < 0
        ? numberWithCommas(
          "(" +
          market_value.replace("-", "") +
          ")" || ""
        )
        : numberWithCommas(
          market_value || ""
        ),
      Unrealized_Gain_Loss: selectedValues?.columns?.includes("Unrealized Gain/(Loss)") && +unrealized_gain_loss < 0
        ? numberWithCommas(
          "(" +
          unrealized_gain_loss.replace(
            "-",
            ""
          ) +
          ")" || ""
        )
        : numberWithCommas(
          unrealized_gain_loss || ""
        ),
      Investment_as_Percentage_of_Market_Value: selectedValues?.columns?.includes("Investment as % Market Value") && +investment_percentage_market_value < 0
        ? numberWithCommas(
          "(" +
          investment_percentage_market_value.replace(
            "-",
            ""
          ) +
          ")" || ""
        )
        : numberWithCommas(
          investment_percentage_market_value ||
          ""
        ),
    }) :
      dataSequence.push({
        Symbol: "Grand Total",
        Market: "",
        Total_Units: selectedValues?.columns?.includes("Total Units") && +total_units < 0
          ? numberWithCommas(
            "(" +
            total_units.replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(total_units || ""),
        Available_Units: selectedValues?.columns?.includes("Available Units") && +units < 0
          ? numberWithCommas(
            "(" +
            units.replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(units || ""),
        Average_Cost_Unit: "",
        Total_Cost_Amount: selectedValues?.columns?.includes("Total Cost / Amount") && +total_amount < 0
          ? numberWithCommas(
            "(" +
            total_amount.replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(
            total_amount || ""
          ),
        Market_Rate_Unit: "",
        Market_Value: selectedValues?.columns?.includes("Market Value") && +market_value < 0
          ? numberWithCommas(
            "(" +
            market_value.replace("-", "") +
            ")"
          )
          : numberWithCommas(market_value),
        Unrealized_Gain_Loss: selectedValues?.columns?.includes("Unrealized Gain/(Loss)") && +unrealized_gain_loss < 0
          ? numberWithCommas(
            "(" +
            unrealized_gain_loss.replace(
              "-",
              ""
            ) +
            ")"
          )
          : numberWithCommas(
            unrealized_gain_loss
          ),
        Investment_as_Percentage_of_Market_Value: selectedValues?.columns?.includes("Investment as % Market Value") && +investment_percentage_market_value < 0
          ? numberWithCommas(
            "(" +
            investment_percentage_market_value.replace(
              "-",
              ""
            ) +
            ")".replace("-", "")
          )
          : numberWithCommas(
            investment_percentage_market_value
          ),
      })

    const reorderColumns = (columns, order) => {
      return order.filter(column => columns.includes(column));
    };

    const reorderedColumns = reorderColumns(selectedValues?.columns, resSelectedPortfolio == "Money Market" ? fixedOrderMM : fixedOrderSM);

    const ArrayData = selectedValues?.columns?.length > 0 && dataSequence?.map(entry => {
      const result = {};
      reorderedColumns.forEach(column => {
        if (column === 'Symbol') {
          result[column] = entry?.Symbol;
        }
        else if (column === 'Average Cost / Unit') {
          result[column] = entry?.Average_Cost_Unit;
        }
        else if (column === 'Total Cost / Amount') {
          result[column] = entry?.Total_Cost_Amount;
        }
        else if (column === 'Market Rate/Unit') {
          result[column] = entry?.Market_Rate_Unit;
        }
        else if (column === 'Market Value') {
          result[column] = entry?.Market_Value;
        }
        else if (column === 'Unrealized Gain/(Loss)') {
          result[column] = numberWithCommas(entry?.Unrealized_Gain_Loss);
        }
        else if (column === 'Investment as % Market Value') {
          result[column] = numberWithCommas(entry?.Investment_as_Percentage_of_Market_Value);
        }
        else if (column === 'Security Type') {
          result[column] = entry?.Security_Type;
        }
        else if (column === 'Name') {
          result[column] = entry?.Name;
        }
        else if (column === 'Issue Date') {
          result[column] = entry?.Issue_Date;
        }
        else if (column === 'Maturity Date') {
          result[column] = entry?.Maturity_Date;
        }
        else if (column === 'Coupon Rate %') {
          result[column] = numberWithCommas(entry?.Coupon_Rate_Percentage);
        }
        else if (column === 'Yield %') {
          result[column] = numberWithCommas(entry?.Yield_Percentage);
        }
        else if (column === 'Money Market Face Value/Unit') {
          result[column] = numberWithCommas(entry?.Money_Market_Face_Value_Unit);
        }
        else if (column === 'Total Face Value') {
          result[column] = numberWithCommas(entry?.Total_Face_Value);
        }
        else if (column === 'Units') {
          result[column] = numberWithCommas(entry?.Units);
        }
        else if (column === 'Market') {
          result[column] = entry?.Market;
        }
        else if (column === 'Total Units') {
          result[column] = numberWithCommas(entry?.Total_Units);
        }
        else if (column === 'Available Units') {
          result[column] = numberWithCommas(entry?.Available_Units);
        }

      });
      return result;

    });

    generateExcel(
      "Daily-Fund-Portfolio-" + date + ".pdf",
      "Daily-Fund-Portfolio-" + date + ".pdf",
      "File",
      "File",
      "DCCL",
      headings,
      reorderedColumns,
      ArrayData,
      [],
      []
    );
  };

  const handleTXT = () => {
    const dataSequence = resSelectedPortfolio == "Money Market" ? moneyMarketPortfolio?.slice(0, itemsToShow)?.map((items) => {
      let coupon_rate = "0",
        yields = "0",
        mmface_value = "0",
        total_face_value = "0",
        units = "0",
        total_amount = "0",
        market_value = "0",
        unrealized_gain_loss = "0",
        investment_percentage_market_value = "0";
      coupon_rate = (
        +coupon_rate + +items.coupon_rate
      ).toFixed(4);
      yields = (
        +yields + +items.yield
      ).toFixed(4);
      mmface_value = (
        +mmface_value + +items.mmface_value
      ).toFixed(4);
      total_face_value = (
        +total_face_value +
        +items.total_face_value
      ).toFixed(4);
      units = (+units + +items.units).toFixed(
        4
      );
      total_amount = (
        +total_amount + +items.total_amount
      ).toFixed(4);
      market_value = (
        +market_value + +items.market_value
      ).toFixed(4);
      unrealized_gain_loss = (
        +unrealized_gain_loss +
        +items.unrealized_gain_loss
      ).toFixed(4);
      investment_percentage_market_value = (
        +investment_percentage_market_value +
        +items.investment_percentage_market_value
      ).toFixed(4);
      return {
        Symbol: items.code,
        Security_Type: items.security_type,
        Name: items.name,
        Issue_Date: items.issue_date,
        Maturity_Date: items.maturity_date,
        Coupon_Rate_Percentage: +items.coupon_rate < 0
          ? numberWithCommas(
            "(" +
            items.coupon_rate
              .toString()
              .replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(
            items.coupon_rate || ""
          ),
        Yield_Percentage: +items.yield < 0
          ? numberWithCommas(
            "(" +
            items.yield
              .toString()
              .replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(
            items.yield || ""
          ),
        Money_Market_Face_Value_Unit: +items.mmface_value < 0
          ? numberWithCommas(
            "(" +
            items.mmface_value
              .toString()
              .replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(
            items.mmface_value || ""
          ),
        Total_Face_Value: +items.total_face_value < 0
          ? numberWithCommas(
            "(" +
            items.total_face_value
              .toString()
              .replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(
            items.total_face_value ||
            ""
          ),
        Units: +items.units < 0
          ? numberWithCommas(
            items.units || ""
          )
          : numberWithCommas(
            items.units || ""
          ),
        Average_Cost_Unit: +items.average_cost_per_unit <
          0
          ? numberWithCommas(
            "(" +
            items.average_cost_per_unit
              .toString()
              .replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(
            items.average_cost_per_unit ||
            ""
          ),
        Total_Cost_Amount: +items.total_amount < 0
          ? numberWithCommas(
            "(" +
            items.total_amount
              .toString()
              .replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(
            items.total_amount || ""
          ),
        Market_Rate_Unit: +items.market_rate_per_unit < 0
          ? numberWithCommas(
            "(" +
            items.market_rate_per_unit
              .toString()
              .replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(
            items.market_rate_per_unit ||
            ""
          ),
        Market_Value: +items.market_value < 0
          ? numberWithCommas(
            "(" +
            items.market_value
              .toString()
              .replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(
            items.market_value || ""
          ),
        Unrealized_Gain_Loss: +items.unrealized_gain_loss < 0
          ? numberWithCommas(
            "(" +
            items.unrealized_gain_loss
              .toString()
              .replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(
            items.unrealized_gain_loss ||
            ""
          ),
        Investment_as_Percentage_of_Market_Value: +items.investment_percentage_market_value <
          0
          ? numberWithCommas(
            "(" +
            items.investment_percentage_market_value
              .toString()
              .replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(
            items.investment_percentage_market_value ||
            ""
          ),
      }
    }) : stockMarketPortfolio?.slice(0, itemsToShow)?.map((items) => {
      let units = "0",
        total_amount = "0",
        total_units = "0",
        market_value = "0",
        unrealized_gain_loss = "0",
        investment_percentage_market_value = "0";
      units = (+units + +items.unit).toFixed(
        4
      );
      total_units = (
        +total_units + +items.total_units
      ).toFixed(4);
      total_amount = (
        +total_amount + +items.amount
      ).toFixed(4);
      market_value = (
        +market_value + +items.market_value
      ).toFixed(4);
      unrealized_gain_loss = (
        +unrealized_gain_loss +
        +items.unrealized_gain_loss
      ).toFixed(4);
      investment_percentage_market_value = (
        +investment_percentage_market_value +
        +items.investment_percentage_market_value
      ).toFixed(4);
      return {
        Symbol: items.code,
        Market: items.market,
        Total_Units: +items.total_units < 0
          ? numberWithCommas(
            "(" +
            items.total_units.replace(
              "-",
              ""
            ) +
            ")" || ""
          )
          : numberWithCommas(
            items.total_units || ""
          ),
        Available_Units: +items.unit < 0
          ? numberWithCommas(
            "(" +
            items.unit.replace(
              "-",
              ""
            ) +
            ")" || ""
          )
          : numberWithCommas(
            items.unit || ""
          ),
        Average_Cost_Unit: +items.average_cost_per_unit <
          0
          ? numberWithCommas(
            "(" +
            items.average_cost_per_unit.replace(
              "-",
              ""
            ) +
            ")"
          )
          : numberWithCommas(
            items.average_cost_per_unit
          ),
        Total_Cost_Amount: +items.amount < 0
          ? numberWithCommas(
            "(" +
            items.amount.replace(
              "-",
              ""
            ) +
            ")" || ""
          )
          : numberWithCommas(
            items.amount
          ),
        Market_Rate_Unit: +items.market_rate_per_unit < 0
          ? numberWithCommas(
            "(" +
            items.market_rate_per_unit.replace(
              "-",
              ""
            ) +
            ")"
          )
          : numberWithCommas(
            items.market_rate_per_unit
          ),
        Market_Value: +items.market_value < 0
          ? numberWithCommas(
            "(" +
            items.market_value.replace(
              "-",
              ""
            ) +
            ")"
          )
          : numberWithCommas(
            items.market_value
          ),
        Unrealized_Gain_Loss: +items.unrealized_gain_loss < 0
          ? numberWithCommas(
            "(" +
            items.unrealized_gain_loss.replace(
              "-",
              ""
            ) +
            ")"
          )
          : numberWithCommas(
            items.unrealized_gain_loss
          ),
        Investment_as_Percentage_of_Market_Value: +items.investment_percentage_market_value <
          0
          ? numberWithCommas(
            "(" +
            items.investment_percentage_market_value.replace(
              "-",
              ""
            ) +
            ")"
          )
          : numberWithCommas(
            items.investment_percentage_market_value
          ),
      }
    })

    resSelectedPortfolio == "Money Market" ? dataSequence.push({
      Symbol: "Grand Total",
      Security_Type: "",
      Name: "",
      Issue_Date: "",
      Maturity_Date: "",
      Coupon_Rate_Percentage: selectedValues?.columns?.includes("Coupon Rate %") && +coupon_rate < 0
        ? numberWithCommas(
          "(" +
          coupon_rate.replace("-", "") +
          ")" || ""
        )
        : numberWithCommas(coupon_rate || ""),
      Yield_Percentage: selectedValues?.columns?.includes("Yield %") && +yields < 0
        ? numberWithCommas(
          "(" +
          yields.replace("-", "") +
          ")" || ""
        )
        : numberWithCommas(yields || ""),
      Money_Market_Face_Value_Unit: selectedValues?.columns?.includes("Money Market Face Value/Unit") && +mmface_value < 0
        ? numberWithCommas(
          "(" +
          mmface_value.replace("-", "") +
          ")" || ""
        )
        : numberWithCommas(
          mmface_value || ""
        ),
      Total_Face_Value: selectedValues?.columns?.includes("Total Face Value") && +total_face_value < 0
        ? numberWithCommas(
          "(" +
          total_face_value.replace(
            "-",
            ""
          ) +
          ")" || ""
        )
        : numberWithCommas(
          total_face_value || ""
        ),
      Units: selectedValues?.columns?.includes("Units") && +units < 0
        ? numberWithCommas(
          "(" +
          units.replace("-", "") +
          ")" || ""
        )
        : numberWithCommas(units || ""),
      Average_Cost_Unit: "",
      Total_Cost_Amount: selectedValues?.columns?.includes("Total Cost / Amount") && +total_amount < 0
        ? numberWithCommas(
          "(" +
          total_amount.replace("-", "") +
          ")" || ""
        )
        : numberWithCommas(
          total_amount || ""
        ),
      Market_Rate_Unit: "",
      Market_Value: selectedValues?.columns?.includes("Market Value") && +market_value < 0
        ? numberWithCommas(
          "(" +
          market_value.replace("-", "") +
          ")" || ""
        )
        : numberWithCommas(
          market_value || ""
        ),
      Unrealized_Gain_Loss: selectedValues?.columns?.includes("Unrealized Gain/(Loss)") && +unrealized_gain_loss < 0
        ? numberWithCommas(
          "(" +
          unrealized_gain_loss.replace(
            "-",
            ""
          ) +
          ")" || ""
        )
        : numberWithCommas(
          unrealized_gain_loss || ""
        ),
      Investment_as_Percentage_of_Market_Value: selectedValues?.columns?.includes("Investment as % Market Value") && +investment_percentage_market_value < 0
        ? numberWithCommas(
          "(" +
          investment_percentage_market_value.replace(
            "-",
            ""
          ) +
          ")" || ""
        )
        : numberWithCommas(
          investment_percentage_market_value ||
          ""
        ),
    }) :
      dataSequence.push({
        Symbol: "Grand Total",
        Market: "",
        Total_Units: selectedValues?.columns?.includes("Total Units") && +total_units < 0
          ? numberWithCommas(
            "(" +
            total_units.replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(total_units || ""),
        Available_Units: selectedValues?.columns?.includes("Available Units") && +units < 0
          ? numberWithCommas(
            "(" +
            units.replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(units || ""),
        Average_Cost_Unit: "",
        Total_Cost_Amount: selectedValues?.columns?.includes("Total Cost / Amount") && +total_amount < 0
          ? numberWithCommas(
            "(" +
            total_amount.replace("-", "") +
            ")" || ""
          )
          : numberWithCommas(
            total_amount || ""
          ),
        Market_Rate_Unit: "",
        Market_Value: selectedValues?.columns?.includes("Market Value") && +market_value < 0
          ? numberWithCommas(
            "(" +
            market_value.replace("-", "") +
            ")"
          )
          : numberWithCommas(market_value),
        Unrealized_Gain_Loss: selectedValues?.columns?.includes("Unrealized Gain/(Loss)") && +unrealized_gain_loss < 0
          ? numberWithCommas(
            "(" +
            unrealized_gain_loss.replace(
              "-",
              ""
            ) +
            ")"
          )
          : numberWithCommas(
            unrealized_gain_loss
          ),
        Investment_as_Percentage_of_Market_Value: selectedValues?.columns?.includes("Investment as % Market Value") && +investment_percentage_market_value < 0
          ? numberWithCommas(
            "(" +
            investment_percentage_market_value.replace(
              "-",
              ""
            ) +
            ")".replace("-", "")
          )
          : numberWithCommas(
            investment_percentage_market_value
          ),
      })

    const reorderColumns = (columns, order) => {
      return order.filter(column => columns.includes(column));
    };

    const reorderedColumns = reorderColumns(selectedValues?.columns, resSelectedPortfolio == "Money Market" ? fixedOrderMM : fixedOrderSM);

    const ArrayData = selectedValues?.columns?.length > 0 && dataSequence?.map(entry => {
      const result = {};
      reorderedColumns.forEach(column => {
        if (column === 'Symbol') {
          result[column] = entry?.Symbol;
        }
        else if (column === 'Average Cost / Unit') {
          result[column] = entry?.Average_Cost_Unit;
        }
        else if (column === 'Total Cost / Amount') {
          result[column] = entry?.Total_Cost_Amount;
        }
        else if (column === 'Market Rate/Unit') {
          result[column] = entry?.Market_Rate_Unit;
        }
        else if (column === 'Market Value') {
          result[column] = entry?.Market_Value;
        }
        else if (column === 'Unrealized Gain/(Loss)') {
          result[column] = numberWithCommas(entry?.Unrealized_Gain_Loss);
        }
        else if (column === 'Investment as % Market Value') {
          result[column] = numberWithCommas(entry?.Investment_as_Percentage_of_Market_Value);
        }
        else if (column === 'Security Type') {
          result[column] = entry?.Security_Type;
        }
        else if (column === 'Name') {
          result[column] = entry?.Name;
        }
        else if (column === 'Issue Date') {
          result[column] = entry?.Issue_Date;
        }
        else if (column === 'Maturity Date') {
          result[column] = entry?.Maturity_Date;
        }
        else if (column === 'Coupon Rate %') {
          result[column] = numberWithCommas(entry?.Coupon_Rate_Percentage);
        }
        else if (column === 'Yield %') {
          result[column] = numberWithCommas(entry?.Yield_Percentage);
        }
        else if (column === 'Money Market Face Value/Unit') {
          result[column] = numberWithCommas(entry?.Money_Market_Face_Value_Unit);
        }
        else if (column === 'Total Face Value') {
          result[column] = numberWithCommas(entry?.Total_Face_Value);
        }
        else if (column === 'Units') {
          result[column] = numberWithCommas(entry?.Units);
        }
        else if (column === 'Market') {
          result[column] = numberWithCommas(entry?.Market);
        }
        else if (column === 'Total Units') {
          result[column] = numberWithCommas(entry?.Total_Units);
        }
        else if (column === 'Available Units') {
          result[column] = numberWithCommas(entry?.Available_Units);
        }

      });
      return result;

    });


    let formattedContent = `${selectedValues?.heading ? selectedValues?.heading : ""},,,\n`;
    formattedContent += `${selectedValues?.sub_heading ? selectedValues?.sub_heading : ""},,,\n`;
    formattedContent += `"Fund:","${resFundCode}",`;
    formattedContent += `"Portfolio:","${resSelectedPortfolio}",,\n`;
    formattedContent += `"Date:","${moment(resCreatedDate).format("DD-MM-YYYY")}",`;
    formattedContent += `"Report Date:","${moment(date).format("DD-MM-YYYY")}",,\n`;

    exportToTxt(formattedContent, selectedValues, ArrayData, "Daily-Fund-Portfolio-" + date + ".pdf")
  }

  const handleShowMore = () => {
    setItemsToShow(prev => prev + itemsPerPage);
  };

  const handleGeneratePdf = () => {
    const element = contentRef.current;
    let fileName = "Daily-Fund-Portfolio.pdf"
    const options = {
      filename: fileName,
      margin: [10, 3, 10, 3],
      image: { type: 'jpeg', quality: 0.95 },
      html2canvas: { scale: 1 },
      jsPDF: { unit: 'mm', format: paperSizeVal || "A4", orientation: layoutVal === "Landscape" ? 'landscape' : "portrait" },
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
    };
    html2pdf()
      .from(element)
      .set(options)
      .save();
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              <div className="">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Daily Fund Portfolio Report</h4>
                  </div>
                  <div className="card-body">
                    <Row>
                      <Col md="2">
                        <div className="form-group">
                          <label>Select Fund</label>
                          <Select
                            className={funCodeErr}
                            value={selectedFundName}
                            label={"Select Fund"}
                            onChange={(e) => {
                              setFundCode(e?.value);
                              setFundCodeErr("");
                              setFundPortfolio([])
                              setItemsPerPage(10)
                              setItemsToShow(10)
                            }}
                            menuPortalTarget={document.body}
                            menuShouldBlockScroll={true}
                            isClearable={true}
                            isSearchable={true}
                            name="color"
                            options={renderFundsDropDown()}
                            styles={customStyles}
                          />
                          {/* <select
                            className={"form-control " + funCodeErr}
                            value={fundCode}
                            onChange={(e) => {
                              setFundCode(e.target.value);
                              setFundCodeErr('');

                            }}>
                            <option value="" defaultChecked hidden>
                              Select Fund
                            </option>
                            {renderFundsDropDown()}
                          </select> */}
                        </div>
                      </Col>
                      <Col md="2">
                        <div className="form-group">
                          <label>Select Portfolio</label>
                          <Select
                            className={selectedPortfolioErr}
                            value={selectedPortfolioVal}
                            label={"Select Portfolio"}
                            onChange={(e) => {
                              setSelectedPortfolio(e?.value);
                              setSelectedPortfolioErr("");
                              if (e?.label === "Money Market") {
                                setColumnArr(ColumnHeadingMM)
                                setSelectedValues({
                                  ...selectedValues,
                                  columns: ColumnHeadingMM?.map?.((col) => col?.label),
                                })
                              }
                              else {
                                setColumnArr(ColumnHeadingSM)
                                setSelectedValues({
                                  ...selectedValues,
                                  columns: ColumnHeadingSM?.map?.((col) => col?.value),
                                })
                              }
                              setFundPortfolio([])
                              setItemsPerPage(10)
                              setItemsToShow(10)
                            }}
                            menuPortalTarget={document.body}
                            menuShouldBlockScroll={true}
                            isClearable={true}
                            isSearchable={true}
                            name="color"
                            options={portfolioArr}
                            styles={customStyles}
                          />
                          {/* <select
                            className={"form-control " + selectedPortfolioErr}
                            value={selectedPortfolio}
                            onChange={(e) => {
                              setSelectedPortfolio(e.target.value);
                              setSelectedPortfolioErr('');

                            }}>
                            <option value="" defaultChecked hidden>
                              Select Portfolio
                            </option>
                            <option value="Money Market">Money Market</option>
                            <option value="Stock Market">Stock Market</option>
                          </select> */}
                        </div>
                      </Col>
                      <Col md="2">
                        <div className="form-group  ">
                          <label>Date</label>
                          <input
                            style={{
                              colorScheme: theme == "light" ? "light" : "dark",
                            }}
                            type="date"
                            value={createdDate}
                            className={"form-control " + createdDateErr}
                            onChange={(e) => {
                              let date = moment(e.target.value).format(
                                "YYYY-MM-DD"
                              );
                              setCreatedDate(date);
                              setCreatedDateErr("");
                              setFundPortfolio([])
                              setItemsPerPage(10)
                              setItemsToShow(10)
                            }}
                          />
                        </div>
                      </Col>

                      <Col md="2">
                        <div className=" ">
                          {/* here Search Button */}
                          <button
                            className="btn btn-primary mt-4"
                            onClick={() => {
                              searchData();
                            }}
                            disabled={Boolean(loading)}
                          >
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border login-txt spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span className="login-txt"> Loading...</span>
                              </>
                            ) : (
                              <span>Search</span>
                            )}
                          </button>
                        </div>
                      </Col>
                    </Row>
                    {/* End */}
                  </div>
                </div>

                {/* here Search results for report Data */}
                <div className="card mt-3">
                  <div className="card-body">
                    {/* ------------------ Report template starts here ---------- */}
                    {fundPortfolio.length > 0 && <Row>
                      <ReportTemplates
                        ColumnArr={ColumnArr}
                        selectedValues={selectedValues}
                        setSelectedValues={setSelectedValues}
                        pdfExportComponent={pdfExportComponent}
                        setFontSizeVal={setFontSizeVal}
                        fontSizeVal={fontSizeVal}
                        setPaperSizeVal={setPaperSizeVal}
                        paperSizeVal={paperSizeVal}
                        setLayoutVal={setLayoutVal}
                        layoutVal={layoutVal}
                        setScalePDF={setScalePDF}
                        scalePDF={scalePDF}
                        setMarginPDF={setMarginPDF}
                        marginPDF={marginPDF}
                        setScreenSizePerPdf={setScreenSizePerPdf}
                        screenSizePerPdf={screenSizePerPdf}
                        setDimensionOfPages={setDimensionOfPages}
                        contentRef={contentRef}
                        fileName={"Daily-Fund-Portfolio-" + date + ".pdf"}
                        printExcel={handleDownloadSampleFile}
                        printTXT={handleTXT}
                        printpdf={handleGeneratePdf}
                      />
                    </Row>}
                    {/* ------------------ Report template ends here ---------- */}
                    <div
                      id="printDiv"
                      className="p-4"
                      style={{
                        // background: "white",
                        color: "black",
                        minWidth: "200px",
                        overflowX: "auto",
                        width: "auto",
                      }}
                    >
                      <div
                        style={{
                          width:
                            `${dimensionOfPages?.find((item) => item?.key == paperSizeVal)?.dimensions[layoutVal == "Portrait" ? 0 : 1]
                            }`,
                          height: 'auto',
                          margin: '0 auto',
                          backgroundColor: "white"
                        }}
                        className="border"
                      >
                        <PDFExport
                          paperSize={paperSizeVal || "A4"}
                          margin="1.5cm"
                          // margin={{ top: marginPDF, left: marginPDF, right: marginPDF, bottom: "1.13cm" }}
                          scale={scalePDF}
                          landscape={layoutVal === "Landscape" ? true : false}
                          repeatHeaders={true}
                          fileName={"Daily-Fund-Portfolio-" + date + ".pdf"}
                          ref={pdfExportComponent}
                        >
                          <div
                            style={{
                              margin: "0.25in"
                            }}
                            ref={contentRef}>
                            {fundPortfolio.length > 0 ? (
                              <>
                                <ReportHeader title="Daily Fund Portfolio" />

                                <Row>
                                  <Col md="4" style={{ marginLeft: "70px" }}>
                                    <Row>
                                      <Col md="5">
                                        <span id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          Fund:
                                        </span>
                                      </Col>
                                      <Col md="6">
                                        <span id="test" className="ReportTopStyling">
                                          {resFundCode}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>
                                  <Col md="4" style={{ marginLeft: "70px" }}>
                                    <Row>
                                      <Col md="5">
                                        <span id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          Portfolio:
                                        </span>
                                      </Col>
                                      <Col md="6">
                                        <span id="test" className="ReportTopStyling">
                                          {resSelectedPortfolio}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>
                                  <Col md="4" style={{ marginLeft: "70px" }}>
                                    <Row>
                                      <Col md="5">
                                        <span id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          Date Date:
                                        </span>
                                      </Col>
                                      <Col md="6">
                                        <span id="test" className="ReportTopStyling">
                                          {moment(resCreatedDate).format(
                                            "DD-MM-YYYY"
                                          )}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>

                                  <Col md="4" style={{ marginLeft: "70px" }}>
                                    <Row>
                                      <Col md="5">
                                        <span id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          Report Date:
                                        </span>
                                      </Col>
                                      <Col md="6">
                                        <span id="test" className="ReportTopStyling">
                                          {moment(date).format("DD-MM-YYYY")}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                                {selectedValues?.columns?.length > 0 ?
                                  <div
                                    style={{
                                      overflowX: "auto",
                                      overflowY: "hidden",
                                    }}
                                  >
                                    {resSelectedPortfolio == "Money Market" ? (
                                      <table
                                        className="report"
                                        style={{ color: "black" }}
                                      >
                                        <thead style={{ alignSelf: "center" }}>
                                          <tr className="header-tr">
                                            {selectedValues?.columns?.includes("Symbol") && <th className="htmltoPdfStyle" id="test">Symbol</th>}
                                            {selectedValues?.columns?.includes("Security Type") && <th className="htmltoPdfStyle" id="test">Security Type</th>}
                                            {selectedValues?.columns?.includes("Name") && <th className="htmltoPdfStyle" id="test">Name</th>}
                                            {selectedValues?.columns?.includes("Issue Date") && <th className="htmltoPdfStyle" id="test">Issue Date</th>}
                                            {selectedValues?.columns?.includes("Maturity Date") && <th className="htmltoPdfStyle" id="test">Maturity Date</th>}
                                            {selectedValues?.columns?.includes("Coupon Rate %") && <th className="htmltoPdfStyle" id="test">Coupon Rate %</th>}
                                            {selectedValues?.columns?.includes("Yield %") && <th className="htmltoPdfStyle" id="test">Yield %</th>}
                                            {selectedValues?.columns?.includes("Money Market Face Value/Unit") && <th className="htmltoPdfStyle" id="test">Money Market Face Value/Unit</th>}
                                            {selectedValues?.columns?.includes("Total Face Value") && <th className="htmltoPdfStyle" id="test">Total Face Value</th>}
                                            {selectedValues?.columns?.includes("Units") && <th className="htmltoPdfStyle" id="test">Units</th>}
                                            {selectedValues?.columns?.includes("Average Cost / Unit") && <th className="htmltoPdfStyle" id="test">Average Cost / Unit</th>}
                                            {selectedValues?.columns?.includes("Total Cost / Amount") && <th className="htmltoPdfStyle" id="test">Total Cost / Amount</th>}
                                            {selectedValues?.columns?.includes("Market Rate/Unit") && <th className="htmltoPdfStyle" id="test">Market Rate/Unit</th>}
                                            {selectedValues?.columns?.includes("Market Value") && <th className="htmltoPdfStyle" id="test">Market Value</th>}
                                            {selectedValues?.columns?.includes("Unrealized Gain/(Loss)") && <th className="htmltoPdfStyle" id="test">Unrealized Gain/(Loss)</th>}
                                            {selectedValues?.columns?.includes("Investment as % Market Value") && <th className="htmltoPdfStyle" id="test">Investment as % Market Value</th>}
                                          </tr>
                                        </thead>
                                        <tbody className="report-table-body">
                                          {moneyMarketPortfolio?.slice(0, itemsToShow).map(
                                            (items: any, index: number) => {
                                              //  if(items.code!==undefined && items.code.startsWith('~~~')==false){
                                              coupon_rate = (
                                                +coupon_rate + +items.coupon_rate
                                              ).toFixed(4);
                                              yields = (
                                                +yields + +items.yield
                                              ).toFixed(4);
                                              mmface_value = (
                                                +mmface_value + +items.mmface_value
                                              ).toFixed(4);
                                              total_face_value = (
                                                +total_face_value +
                                                +items.total_face_value
                                              ).toFixed(4);
                                              units = (+units + +items.units).toFixed(
                                                4
                                              );
                                              total_amount = (
                                                +total_amount + +items.total_amount
                                              ).toFixed(4);
                                              market_value = (
                                                +market_value + +items.market_value
                                              ).toFixed(4);
                                              unrealized_gain_loss = (
                                                +unrealized_gain_loss +
                                                +items.unrealized_gain_loss
                                              ).toFixed(4);
                                              investment_percentage_market_value = (
                                                +investment_percentage_market_value +
                                                +items.investment_percentage_market_value
                                              ).toFixed(4);
                                              return (
                                                <>
                                                  <tr key={index}>
                                                    {selectedValues?.columns?.includes("Symbol") && <td className="htmltoPdfStyle" id="test">{items.code}</td>}
                                                    {selectedValues?.columns?.includes("Security Type") && <td className="htmltoPdfStyle" id="test">{items.security_type}</td>}
                                                    {selectedValues?.columns?.includes("Name") && <td className="htmltoPdfStyle" id="test">{items.name}</td>}
                                                    {selectedValues?.columns?.includes("Issue Date") && <td className="htmltoPdfStyle" id="test">{items.issue_date}</td>}
                                                    {selectedValues?.columns?.includes("Maturity Date") && <td className="htmltoPdfStyle" id="test">{items.maturity_date}</td>}
                                                    {selectedValues?.columns?.includes("Coupon Rate %") && <td className="htmltoPdfStyle" id="test">
                                                      {+items.coupon_rate < 0
                                                        ? numberWithCommas(
                                                          "(" +
                                                          items.coupon_rate
                                                            .toString()
                                                            .replace("-", "") +
                                                          ")" || ""
                                                        )
                                                        : numberWithCommas(
                                                          items.coupon_rate || ""
                                                        )}
                                                    </td>}
                                                    {selectedValues?.columns?.includes("Yield %") && <td className="htmltoPdfStyle" id="test">
                                                      {+items.yield < 0
                                                        ? numberWithCommas(
                                                          "(" +
                                                          items.yield
                                                            .toString()
                                                            .replace("-", "") +
                                                          ")" || ""
                                                        )
                                                        : numberWithCommas(
                                                          items.yield || ""
                                                        )}
                                                    </td>}
                                                    {selectedValues?.columns?.includes("Money Market Face Value/Unit") && <td className="htmltoPdfStyle" id="test">
                                                      {+items.mmface_value < 0
                                                        ? numberWithCommas(
                                                          "(" +
                                                          items.mmface_value
                                                            .toString()
                                                            .replace("-", "") +
                                                          ")" || ""
                                                        )
                                                        : numberWithCommas(
                                                          items.mmface_value || ""
                                                        )}
                                                    </td>}
                                                    {selectedValues?.columns?.includes("Total Face Value") && <td className="htmltoPdfStyle" id="test">
                                                      {+items.total_face_value < 0
                                                        ? numberWithCommas(
                                                          "(" +
                                                          items.total_face_value
                                                            .toString()
                                                            .replace("-", "") +
                                                          ")" || ""
                                                        )
                                                        : numberWithCommas(
                                                          items.total_face_value ||
                                                          ""
                                                        )}
                                                    </td>}
                                                    {selectedValues?.columns?.includes("Units") && <td className="htmltoPdfStyle" id="test">
                                                      {+items.units < 0
                                                        ? numberWithCommas(
                                                          items.units || ""
                                                        )
                                                        : numberWithCommas(
                                                          items.units || ""
                                                        )}
                                                    </td>}
                                                    {selectedValues?.columns?.includes("Average Cost / Unit") && <td className="htmltoPdfStyle" id="test">
                                                      {+items.average_cost_per_unit <
                                                        0
                                                        ? numberWithCommas(
                                                          "(" +
                                                          items.average_cost_per_unit
                                                            .toString()
                                                            .replace("-", "") +
                                                          ")" || ""
                                                        )
                                                        : numberWithCommas(
                                                          items.average_cost_per_unit ||
                                                          ""
                                                        )}
                                                    </td>}
                                                    {selectedValues?.columns?.includes("Total Cost / Amount") && <td className="htmltoPdfStyle" id="test">
                                                      {+items.total_amount < 0
                                                        ? numberWithCommas(
                                                          "(" +
                                                          items.total_amount
                                                            .toString()
                                                            .replace("-", "") +
                                                          ")" || ""
                                                        )
                                                        : numberWithCommas(
                                                          items.total_amount || ""
                                                        )}{" "}
                                                    </td>}
                                                    {selectedValues?.columns?.includes("Market Rate/Unit") && <td className="htmltoPdfStyle" id="test">
                                                      {+items.market_rate_per_unit < 0
                                                        ? numberWithCommas(
                                                          "(" +
                                                          items.market_rate_per_unit
                                                            .toString()
                                                            .replace("-", "") +
                                                          ")" || ""
                                                        )
                                                        : numberWithCommas(
                                                          items.market_rate_per_unit ||
                                                          ""
                                                        )}{" "}
                                                    </td>}
                                                    {selectedValues?.columns?.includes("Market Value") && <td className="htmltoPdfStyle" id="test">
                                                      {+items.market_value < 0
                                                        ? numberWithCommas(
                                                          "(" +
                                                          items.market_value
                                                            .toString()
                                                            .replace("-", "") +
                                                          ")" || ""
                                                        )
                                                        : numberWithCommas(
                                                          items.market_value || ""
                                                        )}{" "}
                                                    </td>}
                                                    {selectedValues?.columns?.includes("Unrealized Gain/(Loss)") && <td className="htmltoPdfStyle" id="test">
                                                      {+items.unrealized_gain_loss < 0
                                                        ? numberWithCommas(
                                                          "(" +
                                                          items.unrealized_gain_loss
                                                            .toString()
                                                            .replace("-", "") +
                                                          ")" || ""
                                                        )
                                                        : numberWithCommas(
                                                          items.unrealized_gain_loss ||
                                                          ""
                                                        )}{" "}
                                                    </td>}
                                                    {selectedValues?.columns?.includes("Investment as % Market Value") && <td className="htmltoPdfStyle" id="test">
                                                      {+items.investment_percentage_market_value <
                                                        0
                                                        ? numberWithCommas(
                                                          "(" +
                                                          items.investment_percentage_market_value
                                                            .toString()
                                                            .replace("-", "") +
                                                          ")" || ""
                                                        )
                                                        : numberWithCommas(
                                                          items.investment_percentage_market_value ||
                                                          ""
                                                        )}{" "}
                                                    </td>}
                                                  </tr>
                                                </>
                                              );
                                              // }
                                            }
                                          )}
                                        </tbody>
                                        <tfoot>
                                          <tr style={{ backgroundColor: "#7eb4d3" }}>
                                            {selectedValues?.columns?.filter((ele) => ele == "Symbol" || ele == "Security Type" || ele == "Name" || ele == "Issue Date" || ele == "Maturity Date")?.length > 0 && <th className="htmltoPdfStyle" id="test" colSpan={selectedValues?.columns?.filter((ele) => ele == "Symbol" || ele == "Security Type" || ele == "Name" || ele == "Issue Date" || ele == "Maturity Date")?.length}>Grand Total</th>}
                                            {/* <td></td> */}
                                            {/* {selectedValues?.columns?.includes("Name") && <th></th>} */}
                                            {/* {selectedValues?.columns?.includes("Issue Date") && <th></th>} */}
                                            {/* {selectedValues?.columns?.includes("Maturity Date") && <th></th>} */}
                                            {selectedValues?.columns?.includes("Coupon Rate %") && <th className="htmltoPdfStyle" id="test">
                                              {+coupon_rate < 0
                                                ? numberWithCommas(
                                                  "(" +
                                                  coupon_rate.replace("-", "") +
                                                  ")" || ""
                                                )
                                                : numberWithCommas(coupon_rate || "")}
                                            </th>}
                                            {selectedValues?.columns?.includes("Yield %") && <th className="htmltoPdfStyle" id="test">
                                              {+yields < 0
                                                ? numberWithCommas(
                                                  "(" +
                                                  yields.replace("-", "") +
                                                  ")" || ""
                                                )
                                                : numberWithCommas(yields || "")}
                                            </th>}
                                            {selectedValues?.columns?.includes("Money Market Face Value/Unit") && <th className="htmltoPdfStyle" id="test">
                                              {+mmface_value < 0
                                                ? numberWithCommas(
                                                  "(" +
                                                  mmface_value.replace("-", "") +
                                                  ")" || ""
                                                )
                                                : numberWithCommas(
                                                  mmface_value || ""
                                                )}
                                            </th>}
                                            {selectedValues?.columns?.includes("Total Face Value") && <th className="htmltoPdfStyle" id="test">
                                              {+total_face_value < 0
                                                ? numberWithCommas(
                                                  "(" +
                                                  total_face_value.replace(
                                                    "-",
                                                    ""
                                                  ) +
                                                  ")" || ""
                                                )
                                                : numberWithCommas(
                                                  total_face_value || ""
                                                )}
                                            </th>}
                                            {selectedValues?.columns?.includes("Units") && <th className="htmltoPdfStyle" id="test">
                                              {+units < 0
                                                ? numberWithCommas(
                                                  "(" +
                                                  units.replace("-", "") +
                                                  ")" || ""
                                                )
                                                : numberWithCommas(units || "")}
                                            </th>}
                                            {selectedValues?.columns?.includes("Average Cost / Unit") && <th></th>}
                                            {selectedValues?.columns?.includes("Total Cost / Amount") && <th className="htmltoPdfStyle" id="test">
                                              {+total_amount < 0
                                                ? numberWithCommas(
                                                  "(" +
                                                  total_amount.replace("-", "") +
                                                  ")" || ""
                                                )
                                                : numberWithCommas(
                                                  total_amount || ""
                                                )}{" "}
                                            </th>}
                                            {selectedValues?.columns?.includes("Market Rate/Unit") && <th></th>}
                                            {selectedValues?.columns?.includes("Market Value") && <th className="htmltoPdfStyle" id="test">
                                              {+market_value < 0
                                                ? numberWithCommas(
                                                  "(" +
                                                  market_value.replace("-", "") +
                                                  ")" || ""
                                                )
                                                : numberWithCommas(
                                                  market_value || ""
                                                )}
                                            </th>}
                                            {selectedValues?.columns?.includes("Unrealized Gain/(Loss)") && <th className="htmltoPdfStyle" id="test">
                                              {+unrealized_gain_loss < 0
                                                ? numberWithCommas(
                                                  "(" +
                                                  unrealized_gain_loss.replace(
                                                    "-",
                                                    ""
                                                  ) +
                                                  ")" || ""
                                                )
                                                : numberWithCommas(
                                                  unrealized_gain_loss || ""
                                                )}{" "}
                                            </th>}
                                            {selectedValues?.columns?.includes("Investment as % Market Value") && <th className="htmltoPdfStyle" id="test">
                                              {+investment_percentage_market_value < 0
                                                ? numberWithCommas(
                                                  "(" +
                                                  investment_percentage_market_value.replace(
                                                    "-",
                                                    ""
                                                  ) +
                                                  ")" || ""
                                                )
                                                : numberWithCommas(
                                                  investment_percentage_market_value ||
                                                  ""
                                                )}{" "}
                                            </th>}
                                          </tr>
                                        </tfoot>
                                      </table>
                                    ) : (
                                      <table
                                        className="report"
                                        style={{ color: "black" }}
                                      >
                                        <thead style={{ alignSelf: "center" }}>
                                          <tr className="header-tr">
                                            {selectedValues?.columns?.includes("Symbol") && <th className="htmltoPdfStyle" id="test">Symbol</th>}
                                            {selectedValues?.columns?.includes("Market") && <th className="htmltoPdfStyle" id="test">Market</th>}
                                            {selectedValues?.columns?.includes("Total Units") && <th className="htmltoPdfStyle" id="test">Total Units</th>}
                                            {selectedValues?.columns?.includes("Available Units") && <th className="htmltoPdfStyle" id="test">Available Units</th>}
                                            {selectedValues?.columns?.includes("Average Cost / Unit") && <th className="htmltoPdfStyle" id="test">Average Cost / Unit</th>}
                                            {selectedValues?.columns?.includes("Total Cost / Amount") && <th className="htmltoPdfStyle" id="test">Total Cost / Amount</th>}
                                            {selectedValues?.columns?.includes("Market Rate/Unit") && <th className="htmltoPdfStyle" id="test">Market Rate/Unit</th>}
                                            {selectedValues?.columns?.includes("Market Value") && <th className="htmltoPdfStyle" id="test">Market Value</th>}
                                            {selectedValues?.columns?.includes("Unrealized Gain/(Loss)") && <th className="htmltoPdfStyle" id="test">Unrealzed Gain/(Loss)</th>}
                                            {selectedValues?.columns?.includes("Investment as % Market Value") && <th className="htmltoPdfStyle" id="test">Investment as % Market Value</th>}
                                          </tr>
                                        </thead>
                                        <tbody className="report-table-body">
                                          {stockMarketPortfolio?.slice(0, itemsToShow).map(
                                            (items: any, index: number) => {
                                              //  if(items.code!==undefined && items.code.startsWith('~~~')==false){
                                              units = (+units + +items.unit).toFixed(
                                                4
                                              );
                                              total_units = (
                                                +total_units + +items.total_units
                                              ).toFixed(4);
                                              total_amount = (
                                                +total_amount + +items.amount
                                              ).toFixed(4);
                                              market_value = (
                                                +market_value + +items.market_value
                                              ).toFixed(4);
                                              unrealized_gain_loss = (
                                                +unrealized_gain_loss +
                                                +items.unrealized_gain_loss
                                              ).toFixed(4);
                                              investment_percentage_market_value = (
                                                +investment_percentage_market_value +
                                                +items.investment_percentage_market_value
                                              ).toFixed(4);
                                              //  }
                                              //  if(items.code!==undefined && items.code.startsWith('~~~')){
                                              //    return (
                                              // <>
                                              // <tr className='footer-tr' key={index}>
                                              // <td>{items.code}</td>
                                              // <td>{items.market}</td>
                                              // <td>{numberWithCommas(items.total_units || '') && numberWithCommas(items.total_units || '')}</td>
                                              // <td>{numberWithCommas(items.unit || '') && numberWithCommas(items.unit || '')}</td>
                                              // <td>{numberWithCommas(items.average_cost_per_unit)}</td>
                                              // <td>{numberWithCommas(items.amount || '') && numberWithCommas(parseFloat(items.amount).toFixed(2))}</td>
                                              // <td>{numberWithCommas(items.market_rate_per_unit)}</td>
                                              // <td>{numberWithCommas(items.market_value)}</td>
                                              // <td>{numberWithCommas(items.unrealized_gain_loss)}</td>
                                              // <td>{numberWithCommas(items.investment_percentage_market_value)}</td>
                                              // </tr>
                                              //   </>
                                              // );
                                              //    }else{
                                              return (
                                                <>
                                                  <tr key={index}>
                                                    {selectedValues?.columns?.includes("Symbol") && <td className="htmltoPdfStyle" id="test">{items.code}</td>}
                                                    {selectedValues?.columns?.includes("Market") && <td className="htmltoPdfStyle" id="test">{items.market}</td>}
                                                    {selectedValues?.columns?.includes("Total Units") && <td className="htmltoPdfStyle" id="test">
                                                      {+items.total_units < 0
                                                        ? numberWithCommas(
                                                          "(" +
                                                          items.total_units.replace(
                                                            "-",
                                                            ""
                                                          ) +
                                                          ")" || ""
                                                        )
                                                        : numberWithCommas(
                                                          items.total_units || ""
                                                        )}
                                                    </td>}
                                                    {selectedValues?.columns?.includes("Available Units") && <td className="htmltoPdfStyle" id="test">
                                                      {+items.unit < 0
                                                        ? numberWithCommas(
                                                          "(" +
                                                          items.unit.replace(
                                                            "-",
                                                            ""
                                                          ) +
                                                          ")" || ""
                                                        )
                                                        : numberWithCommas(
                                                          items.unit || ""
                                                        )}
                                                    </td>}
                                                    {selectedValues?.columns?.includes("Average Cost / Unit") && <td className="htmltoPdfStyle" id="test">
                                                      {+items.average_cost_per_unit <
                                                        0
                                                        ? numberWithCommas(
                                                          "(" +
                                                          items.average_cost_per_unit.replace(
                                                            "-",
                                                            ""
                                                          ) +
                                                          ")"
                                                        )
                                                        : numberWithCommas(
                                                          items.average_cost_per_unit
                                                        )}
                                                    </td>}
                                                    {selectedValues?.columns?.includes("Total Cost / Amount") && <td className="htmltoPdfStyle" id="test">
                                                      {+items.amount < 0
                                                        ? numberWithCommas(
                                                          "(" +
                                                          items.amount.replace(
                                                            "-",
                                                            ""
                                                          ) +
                                                          ")" || ""
                                                        )
                                                        : numberWithCommas(
                                                          items.amount
                                                        )}
                                                    </td>}
                                                    {selectedValues?.columns?.includes("Market Rate/Unit") && <td className="htmltoPdfStyle" id="test">
                                                      {+items.market_rate_per_unit < 0
                                                        ? numberWithCommas(
                                                          "(" +
                                                          items.market_rate_per_unit.replace(
                                                            "-",
                                                            ""
                                                          ) +
                                                          ")"
                                                        )
                                                        : numberWithCommas(
                                                          items.market_rate_per_unit
                                                        )}
                                                    </td>}
                                                    {selectedValues?.columns?.includes("Market Value") && <td className="htmltoPdfStyle" id="test">
                                                      {+items.market_value < 0
                                                        ? numberWithCommas(
                                                          "(" +
                                                          items.market_value.replace(
                                                            "-",
                                                            ""
                                                          ) +
                                                          ")"
                                                        )
                                                        : numberWithCommas(
                                                          items.market_value
                                                        )}
                                                    </td>}
                                                    {selectedValues?.columns?.includes("Unrealized Gain/(Loss)") && <td className="htmltoPdfStyle" id="test">
                                                      {+items.unrealized_gain_loss < 0
                                                        ? numberWithCommas(
                                                          "(" +
                                                          items.unrealized_gain_loss.replace(
                                                            "-",
                                                            ""
                                                          ) +
                                                          ")"
                                                        )
                                                        : numberWithCommas(
                                                          items.unrealized_gain_loss
                                                        )}
                                                    </td>}
                                                    {selectedValues?.columns?.includes("Investment as % Market Value") && <td className="htmltoPdfStyle" id="test">
                                                      {+items.investment_percentage_market_value <
                                                        0
                                                        ? numberWithCommas(
                                                          "(" +
                                                          items.investment_percentage_market_value.replace(
                                                            "-",
                                                            ""
                                                          ) +
                                                          ")"
                                                        )
                                                        : numberWithCommas(
                                                          items.investment_percentage_market_value
                                                        )}
                                                    </td>}
                                                  </tr>
                                                </>
                                              );
                                              //  }
                                            }
                                          )}
                                        </tbody>
                                        <tfoot>
                                          <tr style={{ backgroundColor: "#7eb4d3" }}>
                                            {selectedValues?.columns?.includes("Symbol") && <th className="htmltoPdfStyle" id="test">Grand Total</th>}
                                            {selectedValues?.columns?.includes("Market") && <th>{!selectedValues?.columns?.includes("Symbol") ? "Grand Total" : ""}</th>}
                                            {selectedValues?.columns?.includes("Total Units") && <th className="htmltoPdfStyle" id="test">
                                              {+total_units < 0
                                                ? numberWithCommas(
                                                  "(" +
                                                  total_units.replace("-", "") +
                                                  ")" || ""
                                                )
                                                : numberWithCommas(total_units || "")}
                                            </th>}
                                            {selectedValues?.columns?.includes("Available Units") && <th className="htmltoPdfStyle" id="test">
                                              {+units < 0
                                                ? numberWithCommas(
                                                  "(" +
                                                  units.replace("-", "") +
                                                  ")" || ""
                                                )
                                                : numberWithCommas(units || "")}
                                            </th>}
                                            {selectedValues?.columns?.includes("Average Cost / Unit") && <th></th>}
                                            {selectedValues?.columns?.includes("Total Cost / Amount") && <th className="htmltoPdfStyle" id="test">
                                              {+total_amount < 0
                                                ? numberWithCommas(
                                                  "(" +
                                                  total_amount.replace("-", "") +
                                                  ")" || ""
                                                )
                                                : numberWithCommas(
                                                  total_amount || ""
                                                )}
                                            </th>}
                                            {selectedValues?.columns?.includes("Market Rate/Unit") && <th></th>}
                                            {selectedValues?.columns?.includes("Market Value") && <th className="htmltoPdfStyle" id="test">
                                              {+market_value < 0
                                                ? numberWithCommas(
                                                  "(" +
                                                  market_value.replace("-", "") +
                                                  ")"
                                                )
                                                : numberWithCommas(market_value)}
                                            </th>}
                                            {selectedValues?.columns?.includes("Unrealized Gain/(Loss)") && <th className="htmltoPdfStyle" id="test">
                                              {+unrealized_gain_loss < 0
                                                ? numberWithCommas(
                                                  "(" +
                                                  unrealized_gain_loss.replace(
                                                    "-",
                                                    ""
                                                  ) +
                                                  ")"
                                                )
                                                : numberWithCommas(
                                                  unrealized_gain_loss
                                                )}
                                            </th>}
                                            {selectedValues?.columns?.includes("Investment as % Market Value") && <th className="htmltoPdfStyle" id="test">
                                              {+investment_percentage_market_value < 0
                                                ? numberWithCommas(
                                                  "(" +
                                                  investment_percentage_market_value.replace(
                                                    "-",
                                                    ""
                                                  ) +
                                                  ")".replace("-", "")
                                                )
                                                : numberWithCommas(
                                                  investment_percentage_market_value
                                                )}
                                            </th>}
                                          </tr>
                                        </tfoot>
                                      </table>
                                    )}
                                  </div> :
                                  <div className="text-center my-5">
                                    <b>No column selected</b>
                                  </div>
                                }
                              </>
                            ) : (
                              <div className="table-empty">
                                <BsTable className="icon" />
                                <p className="text-center text-primary empty-text">
                                  No record found
                                </p>
                              </div>
                            )}
                          </div>
                        </PDFExport>
                      </div>
                    </div>

                    <div className="row align-items-center">
                      <div className="col-md-4">
                        <div className="d-flex align-items-center">
                          {(resSelectedPortfolio == "Money Market" ? moneyMarketPortfolio?.length >= 10 : stockMarketPortfolio?.length >= 10) && selectedValues?.columns?.length > 0 &&
                            <UncontrolledDropdown
                              className="me-2 mt-2"
                              direction="down"
                            >
                              <DropdownToggle
                                id="TotalRecord_dropdown"
                                style={{
                                  background: "none",
                                  padding: "0px",
                                  margin: "0px"
                                }}
                                className="border"
                              // style={{
                              //   borderRadius: "4px",
                              //   color: theme == "light" ? "black" : "",
                              // }}
                              // caret
                              // size="sm"
                              >
                                <div
                                  id="report_dropdown"
                                  style={{
                                    borderRadius: "4px",
                                    padding: "5px 15px",
                                    color: theme == "light" ? "black" : "white",
                                  }}
                                >
                                  Per page :{" "}
                                  {
                                    itemsPerPage
                                  }
                                </div>

                                {/* {selectedValues?.columns?.length > 0 &&
                                bankStatementDataCount > 0
                                ? bankStatement?.length
                                : 0} */}
                              </DropdownToggle>
                              <DropdownMenu
                                style={{
                                  // width: "100%",
                                  maxHeight: "300px",
                                  overflow: "auto",
                                  backgroundColor:
                                    theme == "dark" ? "rgb(30, 30, 47)" : "",
                                }}
                              >
                                <DropdownItem
                                  className={
                                    itemsPerPage == 10 ? "bg-info text-white" : ""
                                  }
                                  onClick={() => {
                                    setItemsPerPage(10);
                                    setItemsToShow(10);
                                  }}
                                >
                                  10
                                </DropdownItem>
                                <DropdownItem
                                  className={
                                    itemsPerPage == 25 ? "bg-info text-white" : ""
                                  }
                                  onClick={() => {
                                    setItemsPerPage(25);
                                    setItemsToShow(25);
                                  }}
                                >
                                  25
                                </DropdownItem>
                                <DropdownItem
                                  className={
                                    itemsPerPage == 50 ? "bg-info text-white" : ""
                                  }
                                  onClick={() => {
                                    setItemsPerPage(50);
                                    setItemsToShow(50);
                                  }}
                                >
                                  50
                                </DropdownItem>
                                <DropdownItem
                                  className={itemsPerPage == "All" ? "bg-info text-white" : ""}
                                  onClick={() => {
                                    setItemsPerPage("All")
                                    setItemsToShow((resSelectedPortfolio == "Money Market" ? moneyMarketPortfolio?.length : stockMarketPortfolio?.length));
                                  }}
                                >
                                  All
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>}
                        </div>
                      </div>
                      <div
                        className="col-md-4"
                      >
                        {itemsToShow < (resSelectedPortfolio == "Money Market" ? moneyMarketPortfolio?.length : stockMarketPortfolio?.length) && selectedValues?.columns?.length > 0 && (
                          <div
                            className='d-flex justify-content-center my-2'
                          >
                            <button
                              className="btn btn-primary mt-3"
                              onClick={handleShowMore}
                            >
                              Show More
                            </button>
                          </div>
                        )}
                      </div>
                      <div className="col-md-4">
                        {(resSelectedPortfolio == "Money Market" ? moneyMarketPortfolio?.length > 0 : stockMarketPortfolio?.length > 0) && selectedValues?.columns?.length > 0 && <div className="d-flex align-items-center justify-content-end">
                          <div
                            id="TotalRecord_dropdown"
                            className="border dropdown-toggle btn btn-secondary btn-sm ml-1"
                            style={{
                              borderRadius: "4px",
                              color: theme == "light" ? "black" : "white",
                              marginTop: "13px"
                            }}
                          >
                            Total record : {selectedValues?.columns?.length > 0 ? (resSelectedPortfolio == "Money Market" ? moneyMarketPortfolio?.length : stockMarketPortfolio?.length) : 0}
                          </div>
                        </div>}
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default DailyPortfolioReport;
